// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Sale: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M30.2 48.9c-.4 0-.7-.1-1-.4L1.7 20.9c-.3-.3-.4-.6-.4-1V2.5c0-.8.6-1.4 1.4-1.4h17.4c.4 0 .7.1 1 .4l27.6 27.6c.3.3.4.6.4 1s-.1.7-.4 1L31.2 48.5c-.2.2-.6.4-1 .4zM4.1 19.4l26.2 26.2 15.5-15.5L19.5 3.9H4.1v15.5z"/><path d="M36.9 48.9c-.4 0-.7-.1-1-.4-.5-.5-.5-1.4 0-1.9l16.4-16.4L25.8 3.5c-.5-.5-.5-1.4 0-1.9s1.4-.5 1.9 0l27.6 27.6c.3.3.4.6.4 1s-.1.7-.4 1L37.9 48.5c-.3.2-.6.4-1 .4zm-23.4-30c-3.1 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5 5.5 2.5 5.5 5.5-2.4 5.5-5.5 5.5zm0-8.3c-1.5 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8z"/></svg>;
};

export default React.memo(Sale);
